Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.math?window.GrimoireJS.lib.math.AABB:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-math/ref/AABB.js
// module id = 69
// module chunks = 0